import React from 'react';
import { useButtonTracking } from '@/shared/components/usePageTracking';
import { trackTikTokInitiateCheckout } from '@/services/analytics';

export function CTASection() {
  const { trackClick } = useButtonTracking();

  const handleCTAClick = () => {
    trackClick('Get Your $19 Audit Report', 'CTA Section', {
      section: 'bottom_cta',
      page: 'landing'
    });
    
    // Track TikTok conversion event - initiate checkout for the audit
    trackTikTokInitiateCheckout('audit_report_19', 19, 'USD');
  };

  return (
    <section className="py-20 bg-gradient-to-br from-orange-900 via-red-800 to-orange-900 text-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-block bg-white/10 border border-white/20 rounded-full px-6 py-2 mb-6">
          <span className="text-orange-200 font-semibold text-sm">🚀 COMING SOON</span>
        </div>
        
        <h2 className="text-4xl sm:text-5xl font-bold mb-8">
          Be first in line when we launch
        </h2>
        
        <p className="text-xl sm:text-2xl text-orange-100 mb-12 leading-relaxed">
          Join our waitlist to get early access to automated growth audits for AI-built apps. 
          Plus get exclusive early bird pricing at just $19 (50% off regular price).
        </p>
        
        <div className="mb-12">
          <button 
            onClick={handleCTAClick}
            className="bg-white text-orange-900 font-bold text-xl px-12 py-4 rounded-full hover:bg-orange-50 transform hover:scale-105 transition-all duration-200 shadow-2xl cursor-pointer"
          >
            Join Waitlist - $19 Early Bird
          </button>
        </div>
        
        <div className="flex flex-wrap justify-center items-center gap-8 text-orange-200">
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span>Early access when ready</span>
          </div>
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span>50% off launch price</span>
          </div>
          <div className="flex items-center gap-2">
            <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            <span>Free beta testing access</span>
          </div>
        </div>
      </div>
    </section>
  );
}